import { TFunction } from 'react-i18next';

export enum UsersListTabs {
  ADMIN = 'admins',
  USERS = 'users',
}
export const getUsersTabsConfig = (t: TFunction) => [
  {
    label: t('users_list_tabs_admins'),
    key: UsersListTabs.ADMIN,
  },
  {
    label: t('users_list_tabs_users'),
    key: UsersListTabs.USERS,
  },
];
